import PropTypes from 'prop-types';

export const requirementShape = PropTypes.shape({
  buildingSizeUnits: PropTypes.string,
  city: PropTypes.string,
  id: PropTypes.number,
  investmentTypes: PropTypes.arrayOf(PropTypes.number),
  lotSizeUnits: PropTypes.string,
  maxBuildingSize: PropTypes.number,
  maxLeaseDate: PropTypes.string,
  maxLotSize: PropTypes.number,
  maxNumberOfUnits: PropTypes.number,
  maxSalePrice: PropTypes.number,
  minBuildingSize: PropTypes.number,
  minLeaseDate: PropTypes.string,
  minLotSize: PropTypes.number,
  minNumberOfUnits: PropTypes.number,
  minSalePrice: PropTypes.number,
  name: PropTypes.string,
  notes: PropTypes.string,
  parentId: PropTypes.number,
  parentType: PropTypes.string,
  propertyTypeIds: PropTypes.arrayOf(PropTypes.number),
  state: PropTypes.string,
  transactionType: PropTypes.string,
  updatePath: PropTypes.string,
  zip: PropTypes.string
});

export const FIELDS = {
  BUILDING_CLASS: 'building_class',
  BUILDING_SIZE: 'building_size',
  CAP_RATE: 'cap_rate',
  DOCK_HIGH_DOORS: 'dock_high_doors',
  INVESTMENT_TYPE: 'investment_type',
  LOT_SIZE: 'lot_size',
  TENANCY: 'tenancy',
  UNITS: 'units',
  VACANCY_PERCENT: 'vacancy_percent',
  YEAR_BUILT: 'year_built'
};
